import {
  UNLOCK_LINKEDIN_BANNER_REQUEST,
  UNLOCK_LINKEDIN_BANNER_SUCCESS,
  UNLOCK_LINKEDIN_BANNER_FAILURE,
  RESET_UNLOCK_LINKEDIN_BANNER,
} from "../actionTypes";

const initialState = {
  status: false,
  isLoading: false,
  message: "",
};

const unlockLinkedinBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case UNLOCK_LINKEDIN_BANNER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case UNLOCK_LINKEDIN_BANNER_SUCCESS:
      console.log("us", action.payload);
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case UNLOCK_LINKEDIN_BANNER_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: action.payload.status,
        message: action.payload.message,
      };
    case RESET_UNLOCK_LINKEDIN_BANNER:
      return {
        ...state,
        status: false,
        isLoading: false,
        message: "",
      };
    default:
      return state;
  }
};

export default unlockLinkedinBannerReducer;
